<ng-container *ngIf="smartPackageTanslation$ | async as smartPackageTanslation">
  <div class="row">
    <div class="form-group col-12 zone">
      <label [class.h4]="required">
        {{ label || smartPackageTanslation['AddDocument'] }}
      </label>
      <div
        *ngIf="dropZoneVisible"
        class="dropzone"
        hazmatsuiteNextDnd
        (fileDropped)="onFileDropped($event)"
      >
        <input
          type="file"
          #fileDropRef
          id="fileDropRef"
          [multiple]="multiple"
          (change)="fileBrowseHandler($event.target)"
        />
        <img src="/img/upload.svg" alt="" />
        <h3>
          {{ smartPackageTanslation['DragAndDrop'] }}<br />{{
            smartPackageTanslation['DragAndDropOr']
          }}
        </h3>
        <label class="browse-button" for="fileDropRef">{{
          smartPackageTanslation['ButtonBrowserForFile']
        }}</label>
      </div>
    </div>
  </div>
</ng-container>
